module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financial-gps-wrap"
  }, [_c('h2', [_vm._v(_vm._s(_vm._translate('financialGps.title')))]), _vm._v(" "), (_vm.setStoreTables()) ? _c('div', {
    staticClass: "report-content"
  }, [_c('div', {
    staticClass: "report__block"
  }, [_c('div', {
    staticClass: "report__section"
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.riskBudgetFor')) + " "), _c('span', {
    staticClass: "report__variable",
    domProps: {
      "innerHTML": _vm._s(_vm.getClientName())
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "report__info"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.riskBudgetText')))]), _vm._v(" "), _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.clientName')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getClientName())
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.currentAge')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getClientAge())
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.planStartingYear')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getBaseField('retirement.startPlan'))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.currentYear')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentYear())
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.ageAtRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRetirmentAge())
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.yearOfRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getClientRetirementYear())
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "report__info report__info--large"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.currentValue')) + ": "), _c('span', {
    staticClass: "report__info-highlight",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getClientCurrentValue()))
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.startingAssets')) + " "), (_vm.getBaseField('retirement.statingAssets') === 'auto') ? _c('span', {
    staticClass: "report__list-edit-label"
  }, [_vm._v("(" + _vm._s(_vm._translate('ui.requiredEntry')) + ")")]) : _c('button', {
    staticClass: "reset",
    on: {
      "click": _vm.resetClientStartingAssets
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "reset"
    }
  }), _c('span', {
    staticClass: "reset__label"
  }, [_vm._v(_vm._s(_vm._translate('ui.reset')))])], 1), (_vm.getBaseField('retirement.statingAssets') === 'auto') ? _c('button', {
    staticClass: "apply",
    on: {
      "click": _vm.useSuggestedStartingAssets
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "load"
    }
  }), _c('span', {
    staticClass: "reset__label"
  }, [_vm._v(_vm._s(_vm._translate('ui.reset')))])], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "report__value"
  }, [_c('div', {
    staticClass: "input-wrap input-wrap--text"
  }, [_c('input', {
    class: _vm.getAdjustableInputClass('retirement.statingAssets'),
    attrs: {
      "id": "startingAssets",
      "type": "text",
      "data-type": "currency",
      "placeholder": _vm.getClientStartingAssetsPlaceholder()
    },
    domProps: {
      "value": _vm.getClientStartingAssets()
    },
    on: {
      "change": _vm.saveClientStartingAssets
    }
  })])])]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.assetGoalAtRetirement')) + " "), (_vm.getBaseField('retirement.assetsGoal') === 'auto') ? _c('span', {
    staticClass: "report__list-edit-label"
  }, [_vm._v("(" + _vm._s(_vm._translate('ui.requiredEntry')) + ")")]) : _vm._e(), (_vm.getBaseField('retirement.assetsGoal') !== 'auto') ? _c('button', {
    staticClass: "reset",
    on: {
      "click": _vm.resetClientGoalAtRetirement
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "reset"
    }
  }), _c('span', {
    staticClass: "reset__label"
  }, [_vm._v(_vm._s(_vm._translate('ui.reset')))])], 1) : _vm._e(), (_vm.getBaseField('retirement.assetsGoal') === 'auto') ? _c('button', {
    staticClass: "apply",
    on: {
      "click": _vm.useSuggestedClientGoalAtRetirement
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "load"
    }
  }), _c('span', {
    staticClass: "reset__label"
  }, [_vm._v(_vm._s(_vm._translate('ui.reset')))])], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "report__value"
  }, [_c('div', {
    staticClass: "input-wrap input-wrap--text"
  }, [_c('input', {
    class: _vm.getAdjustableInputClass('retirement.assetsGoal'),
    attrs: {
      "id": "assetGoal",
      "type": "text",
      "data-type": "currency",
      "placeholder": _vm.getClientGloalAtRetirementPlaceholder()
    },
    domProps: {
      "value": _vm.getClientGloalAtRetirement()
    },
    on: {
      "change": _vm.saveClientGloalAtRetirement
    }
  })])])]), _vm._v(" "), (_vm.getClientAge() < _vm.getRetirmentAge()) ? _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.annualContributions')) + " "), (_vm.getBaseField('retirement.annualContributions') === 'auto') ? _c('span', {
    staticClass: "report__list-edit-label"
  }, [_vm._v("(" + _vm._s(_vm._translate('ui.editable')) + ")")]) : _vm._e(), (_vm.getBaseField('retirement.annualContributions') !== 'auto') ? _c('button', {
    staticClass: "reset",
    on: {
      "click": _vm.resetClientAnnualContributions
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "reset"
    }
  }), _c('span', {
    staticClass: "reset__label"
  }, [_vm._v(_vm._s(_vm._translate('ui.reset')))])], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "report__value"
  }, [_c('div', {
    staticClass: "input-wrap input-wrap--text"
  }, [_c('input', {
    class: _vm.getAdjustableInputClass('retirement.annualContributions'),
    attrs: {
      "id": "annualContributions",
      "type": "text",
      "data-type": "currency"
    },
    domProps: {
      "value": _vm.getClientAnnualContributions()
    },
    on: {
      "change": _vm.saveClientAnnualContributions
    }
  })])])]) : _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v("Projected Withdrawal in "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentYearWithdrawalYear())
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getCurrentYearWithdrawal()))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.indexation')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getInflationRate())
    }
  })])]), _vm._v(" "), (_vm.showDependencies()) ? _c('div', [_c('p', {
    staticClass: "report__info"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.assumptions')))]), _vm._v(" "), _c('ul', {
    staticClass: "report__list"
  }, [(!_vm.isRetired()) ? _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.rateOfReturnRequired')) + " "), (_vm.getBaseField('retirement.rateRequired') === 'auto') ? _c('span', {
    staticClass: "report__list-edit-label"
  }, [_vm._v("(" + _vm._s(_vm._translate('ui.editable')) + ")")]) : _vm._e(), (_vm.getBaseField('retirement.rateRequired') !== 'auto') ? _c('button', {
    staticClass: "reset",
    on: {
      "click": _vm.resetInterestRateRequired
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "reset"
    }
  }), _c('span', {
    staticClass: "reset__label"
  }, [_vm._v(_vm._s(_vm._translate('ui.reset')))])], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "report__value"
  }, [_c('div', {
    staticClass: "input-wrap input-wrap--percentage"
  }, [_c('input', {
    class: _vm.getAdjustableInputClass('retirement.rateRequired'),
    attrs: {
      "id": "rateRequired",
      "type": "number",
      "data-type": "percentage"
    },
    domProps: {
      "value": _vm.getInterestRateRequired()
    },
    on: {
      "change": _vm.saveInterestRateRequired
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.rateOfReturnRequiredRetirement')) + " "), (_vm.getBaseField('retirement.retirementRate') === 'auto') ? _c('span', {
    staticClass: "report__list-edit-label"
  }, [_vm._v("(" + _vm._s(_vm._translate('ui.editable')) + ")")]) : _vm._e(), (_vm.getBaseField('retirement.retirementRate') !== 'auto') ? _c('button', {
    staticClass: "reset",
    on: {
      "click": _vm.resetInterestRateRetirement
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "reset"
    }
  }), _c('span', {
    staticClass: "reset__label"
  }, [_vm._v(_vm._s(_vm._translate('ui.reset')))])], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "report__value"
  }, [_c('div', {
    staticClass: "input-wrap input-wrap--percentage"
  }, [_c('input', {
    class: _vm.getAdjustableInputClass('retirement.retirementRate'),
    attrs: {
      "id": "rateRequired",
      "type": "number",
      "data-type": "percentage"
    },
    domProps: {
      "value": _vm.getInterestRateRetirement()
    },
    on: {
      "change": _vm.saveInterestRateRetirement
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "report__info report__info--large"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.adjustmentTitle')))]), _vm._v(" "), _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item report__list-item--checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "id": "active",
      "label": _vm._translate('financialGps.useAdjusted'),
      "field": "retirement.useAdjusted",
      "value": "true"
    }
  })], 1), _vm._v(" "), (_vm.getBaseField('retirement.useAdjusted')) ? _c('li', [(_vm.getBaseField('retirement.useAdjusted')) ? _c('p', {
    staticClass: "report__info"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.adjustmentText')))]) : _vm._e(), _vm._v(" "), (_vm.getBaseField('retirement.useAdjusted')) ? _c('p', {
    staticClass: "report__info"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.adjustmentText2')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getBaseField('retirement.useAdjusted')) ? _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.adjustedGoal')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value adjusted",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getClientAdjustedGoalAtRetirement()))
    }
  })]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "report__section"
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.financialGpsProjections')))]), _vm._v(" "), (_vm.showDependencies()) ? _c('div', [_c('p', {
    staticClass: "report__info"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.financialGpsProjectionsParagraph1')))]), _vm._v(" "), _c('p', {
    staticClass: "report__info"
  }, [_vm._v(_vm._s(_vm._translate('financialGps.financialGpsProjectionsParagraph2')))]), _vm._v(" "), (this.$data.report !== 'start') ? _c('div', {
    staticClass: "report-ctrl"
  }, [_c('ul', {
    staticClass: "report-tabs report-tabs--chart"
  }, [_c('li', {
    class: _vm.setGPSViewClass('savings')
  }, [_c('button', {
    staticClass: "report-tabs__button",
    on: {
      "click": function($event) {
        _vm.setActiveGPSView('savings', 'GPSProjectionChart', 1, 2)
      }
    }
  }, [_vm._v(_vm._s(_vm._translate('financialGps.savings')))])]), _c('li', {
    class: _vm.setGPSViewClass('retirement')
  }, [_c('button', {
    staticClass: "report-tabs__button",
    on: {
      "click": function($event) {
        _vm.setActiveGPSView('retirement', 'GPSProjectionChart', 2, 2)
      }
    }
  }, [_vm._v(_vm._s(_vm._translate('financialGps.retirement')))])])]), _vm._v(" "), _c('button', {
    class: _vm.buttonClass('wealthAccumulation', 'list'),
    on: {
      "click": function($event) {
        _vm.buttonChange()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "target"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chart-slider",
    attrs: {
      "id": "GPSProjectionChart"
    }
  }, [_c('div', {
    staticClass: "chart-slider__wrapper",
    style: (_vm.setInitialGPSView),
    attrs: {
      "id": "GPSProjectionChart__wrapper"
    }
  }, [_c('div', {
    staticClass: "chart-slider__chart"
  }, [_c('Chart', {
    attrs: {
      "type": "line",
      "stacked": "false",
      "data": _vm.chartWealthProjection('savings'),
      "id": "GPSwealthProjection"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-slider__chart"
  }, [_c('Chart', {
    attrs: {
      "type": "line",
      "stacked": "false",
      "data": _vm.chartWealthProjection('retirement'),
      "id": "GPSwithdrawalProjection"
    }
  })], 1)])])]) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.requestStartingAssets())
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47b41f3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinancialGPS/FinancialGPS.vue
// module id = 318
// module chunks = 0